
import env from '@/.env.json';

export default {
  name: 'OrderListItem',
  props: {
    title: {
      type: String,
      default: '',
    },
    caption: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isTitleBold: !env.DELIVERY_INFO_THIN,
    }
  },
}
